const styles = {
  root: {},
  indicator: {},
};

export default styles;
